var scope_0 = require('/home/runner/work/yunusemre.dev/yunusemre.dev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/48085299b3a79e781c41d756dafcba3f.js').default;
var scope_1 = require('/home/runner/work/yunusemre.dev/yunusemre.dev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d147925424acc6f751c6e5dd633ee943.js').default;
var scope_2 = require('/home/runner/work/yunusemre.dev/yunusemre.dev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    